module.exports = __webpack_public_path__ + "static/img/text.c1e90e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcwy/images/text.png
// module id = xxaO
// module chunks = 1